// @ts-check

import React, { useState } from "react";
import "../styles/WebResultsPage.css";


// @ts-ignore
import luLogo from "../images/LU--black.svg";
// @ts-ignore
import drwText from "../images/donor_recognition_wall--black.svg";
// @ts-ignore
import donateBtnImg from "../images/donate_icon.svg";
// @ts-ignore
import searchIcon from "../images/search_icon--white.svg";
// @ts-ignore
import removeSearchIcon from "../images/remove_search.svg";


import WebResultsCampaignContent from "./WebResultsCampaignContent";
import WebResultsDonorsContent from "./WebResultsDonorsContent";

import ChooseCampaignLightbox from "./ChooseCampaignLightbox";

// eslint-disable-next-line
import { rcs_CAMPAIGN, rcs_DONORS, rcs_NONE } from "./WebLandingPage";


/**
 * @typedef {
        [rcs_NONE, null] |
        [rcs_DONORS, string] |
        [rcs_CAMPAIGN, string]
    } ResultsContentState 
 */

/**
 * @param {{ 
 *   resultsContentState: ResultsContentState, 
 *   onResultsContentStateChanged: (a: ResultsContentState) => void,
 *   searchString: string, 
 *   onSearchStringChanged: (a: string) => void,
 *   goToLanding: () => void
 *   }
 * } props 
 * @returns {JSX.Element}
 */
function WebResultsPage(props) {
    
    const [lastSearchStringUsed, setLastSearchStringUsed] = useState(props.searchString);

    const [showCampaignLightBox, setShowCampaignLightBox] = useState(false);


    const shouldDisplayRemoveSearchIcon = 
        (lastSearchStringUsed !== "") && (lastSearchStringUsed === props.searchString);


    // @ts-ignore
    const performSearch = e => { 
        setLastSearchStringUsed(props.searchString);
        props.onResultsContentStateChanged([rcs_DONORS, props.searchString]);
    };

    // @ts-ignore
    const clearOutSearch = e => { 
        setLastSearchStringUsed(""); 
        props.onSearchStringChanged("");
    };


    const selectCampaign = (campQueryName) => {
        props.onSearchStringChanged("");
        props.onResultsContentStateChanged([rcs_CAMPAIGN, campQueryName]);
    };


    let contentsPage = null;


    switch (props.resultsContentState[0]) {
        case rcs_DONORS: contentsPage = (<WebResultsDonorsContent donorName={props.resultsContentState[1]} />); break;
        case rcs_CAMPAIGN: contentsPage = (<WebResultsCampaignContent campQueryName={props.resultsContentState[1]} />); break;
        default: break;
    }


    const body = (
        <>
            {showCampaignLightBox && 
                <ChooseCampaignLightbox 
                    cancelLightbox={() => { setShowCampaignLightBox(false); }} 
                    selectCampaign={selectCampaign} />}
            <div className="web-res__banner">
                <table className="web-res__banner__table">
                    <tbody>
                        <tr>
                            <td>
                                <div className="web-res__banner__left">
                                    <div className="web-res__search__container">
                                        <input 
                                            type="text" 
                                            className="web-res__search__field"
                                            aria-label="Search for a donor by name" 
                                            placeholder="Search for a donor by name"
                                            value={props.searchString} 
                                            onChange={e => props.onSearchStringChanged(e.target.value)} 
                                            onKeyUp={e => {
                                                if (e.key === "Enter") { performSearch(); }
                                            }} />
                                        <input type="button" className="web-res__search__btn" aria-label="Submit search" onClick={performSearch} />
                                        <img src={searchIcon} className="web-res__search__icon" alt="Search" />
                                        { shouldDisplayRemoveSearchIcon && 
                                            <img 
                                                src={removeSearchIcon} 
                                                className="web-res__search__remove-search"
                                                onClick={clearOutSearch} alt="Remove search text" />}
                                    </div>
                                    <div className="web-res__or-container">
                                        <div className="web-res__or-divider" />
                                        <p className="web-res__or-text">or</p>
                                        <div className="web-res__or-divider" />
                                    </div>
                                    <input type="button" aria-haspopup="true" className="web-res__campaign-btn" value="Browse By Campaign" onClick={() => { 
                                        setShowCampaignLightBox(true);
                                        } }/>
                                </div>
                            </td>
                            <td className="web-res__banner__td__center">
                                <div className="web-res__banner__center">
                                        <img src={luLogo} className="web-res__logo-name" alt="Liberty University" onClick={props.goToLanding} />
                                        <img src={drwText} className="web-res__drw-text-name" alt="Donor Recognition Wall" onClick={props.goToLanding} />
                                </div>
                            </td>
                            <td className="web-res__banner__td__right">
                                <div className="web-res__banner__right">
                                    <a href="https://www.liberty.edu/giving/" className="web-res__banner__donate-container web-res__banner---__link-style-undo">
                                        <img src={donateBtnImg} className="web-res__banner_donate-btn-img" alt="Donate" />
                                        <input type="button" className="web-res__banner__donate-btn" value="Donate & Be Recognized" />
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="web-res__content">
                {contentsPage}
            </div>
        </>
    );

    return (
        <>{
            showCampaignLightBox ?
            <div className="web-res__root web-res__root--no-scroll" tabIndex={ -1 }>{body}</div>
            : <div className="web-res__root web-res__root--scroll" tabIndex={ 0 }>{body}</div>
        }</>);
}



export default WebResultsPage;
